<template>
  <!-- ************************************************** --
    -- 絞り込みダイアログ
    -- ************************************************** -->
    <!-- 車両チップ -->
    <v-dialog v-model="showDialog" height="80%" width="900" max-width="90%" style="z-index:500" persistent no-click-animation>
      <v-card>
        <v-toolbar elevation="1" color="#6091d3" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>車両情報絞り込み</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="onClickCarFilterClose" text><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row no-gutters align-content="center" class="my-1">
              <div class="px-1" style="font-weight:bold;color:navy">入力した内容で絞り込みされます。</div>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="12">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    乗務員:
                  <span v-for="item in carFilterDriver" v-bind:key = item.code style="padding:6px">
                      <label>
                      <input type="checkbox" :value="item.code" v-model="item.value" />
                      {{ item.code }}:{{ item.name }}
                      </label>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="12">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    {{ title2 }}:
                  <span v-for="item in carFilterYosha" v-bind:key = item.code style="padding:6px">
                      <label>
                      <input type="checkbox" :value="item.code" v-model="item.value" />
                      {{ item.code }}:{{ item.name }}
                      </label>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="3">
                <v-row no-gutters align-content="center">
                  <v-col :cols=12 class="px-1">
                    <dd-code-text-box
                      label="車両番号/自動車表示名"
                      v-model="carFilterConditions.sharyoCd"
                      :length="100"
                      :valueType="Ctrls.InputTypes.Alphanumeric"
                      titleText="車両マスタ検索"
                      :headerList="mstSharyoHeaders"
                      item-value="sharyoCd"
                      item-text="torokuNo"
                      :itemList="filteredMstSharyo"/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols="6">
                <v-row no-gutters align-content="center">
                  <v-col :cols=12 class="px-1">
                    <dd-text-box
                      label="車両あいまい検索"
                      v-model="carFilterConditions.jidoshaHyojiNm"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols="3" class="px-1">
                <dd-drop-down
                  label="車両種別"
                  v-model="carFilterConditions.shashuSbt"
                  placeholder="選択してください"
                  :items="filteredSharyoShubetsList"
                  />
              </v-col>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="3">
                <v-row no-gutters align-content="center">
                  <v-col :cols=12 class="px-1">
                    <dd-code-text-box
                      label="管理営業所コード/名称"
                      v-model="carFilterConditions.eigyoshoCd"
                      :length="100"
                      :valueType="Ctrls.InputTypes.Alphanumeric"
                      titleText="営業所マスタ検索"
                      :headerList="mstEigyoshoHeaders"
                      item-value="eigyoshoCd"
                      item-text="eigyoshoNm"
                      :itemList="filteredEigyoshoList"/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols=6>
                <v-row no-gutters align-content="center">
                  <v-col :cols=12 class="px-1">
                    <dd-text-box
                      label="管理営業所あいまい検索"
                      v-model="carFilterConditions.eigyoshoNm"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickCarFilterClose">閉じる</v-btn>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickCarFilterClear">クリア</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickCarFilterExec">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//
// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDropDown = () => import('@/components/DdDropDown')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdHaishaCarFilterDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    // DdCheckbox,
    DdCodeTextBox,
    // DdDataTable,
    // DdDateBox,
    // DdDefaultButton,
    DdDropDown,
    // DdFooterButton,
    // DdIconButtonWithTooltip,
    // DdNumericBox,
    // DdRadioButton,
    // DdSimpleTable,
    // DdSubHeader,
    // DdSubTitle,
    // DdSwitch,
    // DdTextArea,
    DdTextBox
    // DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: {
      sharyoCd: '',
      jidoshaHyojiNm: '',
      shashuSbt: '',
      eigyoshoCd: '',
      eigyoshoNm: '',
      onDriver: 0, // 0: all 1:有 2:無,
      onYosha: 0 //  0: all 1:自社 2:傭車
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,

    // 乗務員フィルター初期値
    carFilterDriver: [
      {
        code: '0',
        name: '有',
        value: true
      },
      {
        code: '1',
        name: '無',
        value: true
      }
    ],

    // 乗務員フィルター初期値
    carFilterYosha: [
      {
        code: '0',
        name: '自社',
        value: true
      },
      {
        code: '1',
        name: '傭車',
        value: true
      }
    ],

    // 車両情報フィルター初期値
    carFilterConditions: {
      sharyoCd: '',
      jidoshaHyojiNm: '',
      shashuSbt: '',
      eigyoshoCd: '',
      eigyoshoNm: '',
      onDriver: 0, // 0: all 1:有 2:無,
      onYosha: 0 //  0: all 1:自社 2:傭車
    },

    // 戻り値用定義
    rec: {
      id: 0
    },
    title2: '車　両'
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        this.carFilterConditions = Object.assign({}, this.param)
        if (this.carFilterConditions.onDriver === 1) {
          this.carFilterDriver[0].value = true
          this.carFilterDriver[1].value = false
        } else if (this.carFilterConditions.onDriver === 2) {
          this.carFilterDriver[0].value = false
          this.carFilterDriver[1].value = true
        } else {
          this.carFilterDriver[0].value = true
          this.carFilterDriver[1].value = true
        }
        if (this.carFilterConditions.onYosha === 1) {
          this.carFilterYosha[0].value = true
          this.carFilterYosha[1].value = false
        } else if (this.carFilterConditions.onYosha === 2) {
          this.carFilterYosha[0].value = false
          this.carFilterYosha[1].value = true
        } else {
          this.carFilterYosha[0].value = true
          this.carFilterYosha[1].value = true
        }
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu'
    }),

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    }
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      const opt = {
        loadMasters: [],
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rec.chipColor = '#00FF00'
      this.chipColorTmp = this.rec.chipColor
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickCarFilterClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickCarFilterExec: function (e) {
      console.log(this.param)

      if (this.carFilterDriver[0].value === true && this.carFilterDriver[1].value === false) {
        this.carFilterConditions.onDriver = 1
      } else if (this.carFilterDriver[0].value === false && this.carFilterDriver[1].value === true) {
        this.carFilterConditions.onDriver = 2
      } else {
        this.carFilterConditions.onDriver = 0
      }
      if (this.carFilterYosha[0].value === true && this.carFilterYosha[1].value === false) {
        this.carFilterConditions.onYosha = 1
      } else if (this.carFilterYosha[0].value === false && this.carFilterYosha[1].value === true) {
        this.carFilterConditions.onYosha = 2
      } else {
        this.carFilterConditions.onYosha = 0
      }
      console.log(this.carFilterConditions)
      this.$emit('exec', this.carFilterConditions)
    },
    // --------------------------------------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------------------------------------
    onClickCarFilterClear: function (e) {
      Object.assign(this.carFilterConditions, this.$options.data().carFilterConditions)
      this.$emit('exec', this.carFilterConditions)
    }
  }
}
</script>
<style></style>
